import { useTranslation } from "@/hooks/useTranslation"

export const useAppRegistrationTranslation = () =>
  useTranslation("translation", {
    keyPrefix: "deployments.copilotStudio.appRegistration"
  }).t
